// @flow
import update from 'immutability-helper';
import { of } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { map, catchError, mergeMap } from 'rxjs/operators';
import { setNewAlert } from '../../../alert/duck';
import { endpoints, postPositiveFeedbackApi, postNegativeFeedbackApi, postFeedbackApi } from './api';

import type { HTTPError } from '../../../../error';
import type { Order } from '../../../../entities';
import type { Observable } from 'rxjs';
import type { RootState } from '../../../index';

type FeedbackAction = {
  +type: string;
  +error?: HTTPError;
  +order?: Order;
  +orderId?: string;
  +feedback?: string;
  +isGood?: boolean;
};

export type FeedbackState = {
  +isPostingFeedback?: boolean;
  +postFeedbackSuccessful?: boolean;
  +postFeedbackError?: HTTPError;
};

// Actions
/*const FEEDBACK_POST_POSITIVE_FEEDBACK_REQUEST = 'FEEDBACK_POST_POSITIVE_FEEDBACK_REQUEST';
const FEEDBACK_POST_POSITIVE_FEEDBACK_SUCCESS = 'FEEDBACK_POST_POSITIVE_FEEDBACK_SUCCESS';
const FEEDBACK_POST_POSITIVE_FEEDBACK_ERROR = 'FEEDBACK_POST_POSITIVE_FEEDBACK_ERROR';
const FEEDBACK_POST_NEGATIVE_FEEDBACK_REQUEST = 'FEEDBACK_POST_NEGATIVE_FEEDBACK_REQUEST';
const FEEDBACK_POST_NEGATIVE_FEEDBACK_SUCCESS = 'FEEDBACK_POST_NEGATIVE_FEEDBACK_SUCCESS';
const FEEDBACK_POST_NEGATIVE_FEEDBACK_ERROR = 'FEEDBACK_POST_NEGATIVE_FEEDBACK_ERROR';*/

const FEEDBACK_POST_FEEDBACK_REQUEST = 'FEEDBACK_POST_FEEDBACK_REQUEST';
const FEEDBACK_POST_FEEDBACK_SUCCESS = 'FEEDBACK_POST_FEEDBACK_SUCCESS';
const FEEDBACK_POST_FEEDBACK_ERROR = 'FEEDBACK_POST_FEEDBACK_ERROR';

// Action Creators
/*export function postPositiveFeedback(orderId: string, feedback?: string): FeedbackAction {
  return {
    type: FEEDBACK_POST_POSITIVE_FEEDBACK_REQUEST,
    orderId,
    feedback,
  };
}

export function postPositiveFeedbackSuccess(order: Order): FeedbackAction {
  return {
    type: FEEDBACK_POST_POSITIVE_FEEDBACK_SUCCESS,
    order,
  };
}

export function postPositiveFeedbackErrorFn(error: HTTPError): FeedbackAction {
  return {
    type: FEEDBACK_POST_POSITIVE_FEEDBACK_ERROR,
    error,
  };
}

export function postNegativeFeedback(orderId: string, feedback?: string): FeedbackAction {
  return {
    type: FEEDBACK_POST_NEGATIVE_FEEDBACK_REQUEST,
    orderId,
    feedback,
  };
}

export function postNegativeFeedbackSuccess(order: Order): FeedbackAction {
  return {
    type: FEEDBACK_POST_NEGATIVE_FEEDBACK_SUCCESS,
    order,
  };
}

export function postNegativeFeedbackErrorFn(error: HTTPError): FeedbackAction {
  return {
    type: FEEDBACK_POST_NEGATIVE_FEEDBACK_ERROR,
    error,
  };
}*/

export function postFeedback(orderId: string, isGood: boolean, feedback?: string): FeedbackAction {
  return {
    type: FEEDBACK_POST_FEEDBACK_REQUEST,
    orderId,
    feedback,
    isGood,
  };
}

export function postFeedbackSuccess(order: Order): FeedbackAction {
  return {
    type: FEEDBACK_POST_FEEDBACK_SUCCESS,
    order,
  };
}

export function postFeedbackErrorFn(error: HTTPError): FeedbackAction {
  return {
    type: FEEDBACK_POST_FEEDBACK_ERROR,
    error,
  };
}


export const actions = {
  /*FEEDBACK_POST_POSITIVE_FEEDBACK_REQUEST,
  FEEDBACK_POST_POSITIVE_FEEDBACK_SUCCESS,
  FEEDBACK_POST_POSITIVE_FEEDBACK_ERROR,
  FEEDBACK_POST_NEGATIVE_FEEDBACK_REQUEST,
  FEEDBACK_POST_NEGATIVE_FEEDBACK_SUCCESS,
  FEEDBACK_POST_NEGATIVE_FEEDBACK_ERROR,*/
  FEEDBACK_POST_FEEDBACK_REQUEST,
  FEEDBACK_POST_FEEDBACK_SUCCESS,
  FEEDBACK_POST_FEEDBACK_ERROR,
  /*postPositiveFeedback,
  postPositiveFeedbackSuccess,
  postPositiveFeedbackErrorFn,
  postNegativeFeedback,
  postNegativeFeedbackSuccess,
  postNegativeFeedbackErrorFn,*/
  postFeedback,
  postFeedbackSuccess,
  postFeedbackErrorFn,
};

export const initialState: FeedbackState = {};

// Reducer
export default function reducer(state: FeedbackState = initialState,
                                action: FeedbackAction): FeedbackState {
  switch (action.type) {
    /*case FEEDBACK_POST_POSITIVE_FEEDBACK_REQUEST:
    case FEEDBACK_POST_NEGATIVE_FEEDBACK_REQUEST:*/
    case FEEDBACK_POST_FEEDBACK_REQUEST:
      return update(state, {
        $unset: ['postFeedbackError', 'postFeedbackSuccessful'],
        isPostingFeedback: { $set: true },
      });
    /*case FEEDBACK_POST_POSITIVE_FEEDBACK_SUCCESS:
    case FEEDBACK_POST_NEGATIVE_FEEDBACK_SUCCESS:*/
    case FEEDBACK_POST_FEEDBACK_SUCCESS:
      return update(state, {
        $unset: ['isPostingFeedback'],
        postFeedbackSuccessful: { $set: true },
      });
    /*case FEEDBACK_POST_POSITIVE_FEEDBACK_ERROR:
    case FEEDBACK_POST_NEGATIVE_FEEDBACK_ERROR:*/
    case FEEDBACK_POST_FEEDBACK_ERROR:
      return update(state, {
        $unset: ['isPostingFeedback'],
        postFeedbackError: { $set: action.error },
      });
    default:
      return state;
  }
}

// Epics
export function postFeedbackEpic(action$: Observable<FeedbackAction>,
                                 state$: StateObservable<RootState>): Observable<FeedbackAction> {
  return action$.pipe(
    ofType(FEEDBACK_POST_FEEDBACK_REQUEST),
    mergeMap(({ orderId, isGood }) => postFeedbackApi({
      isGood,
    }, {
      route: endpoints.POST_FEEDBACK.replace(':orderId', orderId),
    }).pipe(
      map(() => {
        const o = update(state$.value.order.order, {
          travelerReview: { $set: isGood },
        });
        return postFeedbackSuccess(o);
      }),
      catchError((e: HTTPError) => of(postFeedbackErrorFn(e)))
    )),
  );
}



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/feedback/duck.js